import React, { useState } from "react";
import StepShell from "./StepShell";
import copy from "../copy";

const BirthYearStep = ({ data, handleChange, onNext, onBack }) => {
  const [year, setYear] = useState(data.birth_year || "");

  const onChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setYear(value);
    handleChange("birth_year", value);
  };

  const n = Number(year);
  const valid = /^\d{4}$/.test(year) && n >= 1900 && n <= new Date().getFullYear();

  return (
    <StepShell title={copy.birth.title} subtitle={copy.birth.text} onBack={onBack}>
      <form
        className="rp-form"
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) onNext();
        }}
      >
        <input
          className="rp-input"
          type="text"
          name="birth_year"
          inputMode="numeric"
          autoComplete="bday-year"
          maxLength={4}
          aria-label={copy.birth.title}
          value={year}
          onChange={onChange}
        />
        <div className="rp-actions">
          <button type="submit" className="rp-btn" disabled={!valid}>
            {copy.next}
          </button>
        </div>
      </form>
    </StepShell>
  );
};

export default BirthYearStep;
